"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasTravelRoomsEmptyDates = exports.isTravelRoomsValid = exports.validateChildren = exports.validateChildDob = exports.getShortInformation = exports.FOUR_MAX_ROOMS_COUNT = exports.MAX_ROOMS_COUNT_DEFAULT = exports.MAX_TRAVELLERS_FOR_FOUR_ROOMS = exports.MAX_TRAVELERS_FOR_ONE_ROOM = exports.MAX_TRAVELLERS_DEFAULT = exports.MAX_CHILD_AGE = void 0;
const components_common_dob_input_1 = require("@hotelplan/components.common.dob-input");
const libs_utils_1 = require("@hotelplan/libs.utils");
exports.MAX_CHILD_AGE = 16;
exports.MAX_TRAVELLERS_DEFAULT = 8;
exports.MAX_TRAVELERS_FOR_ONE_ROOM = 6;
exports.MAX_TRAVELLERS_FOR_FOUR_ROOMS = 15;
exports.MAX_ROOMS_COUNT_DEFAULT = 2;
exports.FOUR_MAX_ROOMS_COUNT = 4;
const getShortInformation = (t, { rooms, adults, childrenDobs }, sticky) => {
    const postfix = sticky ? '.short' : '';
    return [
        rooms > 0 ? t(`common:room.count${postfix}`, { count: rooms }) : '',
        adults > 0 ? t(`common:adult.count${postfix}`, { count: adults }) : '',
        childrenDobs.length > 0
            ? t('common:child.count', { count: childrenDobs.length })
            : '',
    ]
        .filter(Boolean)
        .join(', ');
};
exports.getShortInformation = getShortInformation;
const getDefaultOldestChildBirthDate = () => {
    return (0, libs_utils_1.subtractYears)((0, libs_utils_1.getTodaysDate)(), exports.MAX_CHILD_AGE);
};
function validateChildDob(childDob) {
    if (!childDob || /_+/.exec(childDob))
        return true;
    const dob = (0, components_common_dob_input_1.parseDateInputValue)(childDob || '');
    if (!dob)
        return false;
    if (components_common_dob_input_1.validators.hasBlankParts(dob))
        return false;
    if (!components_common_dob_input_1.validators.isUserDateExists(dob))
        return false;
    if (components_common_dob_input_1.validators.isUserDateAfterSomeDate(dob, (0, libs_utils_1.getTodaysDate)()))
        return false;
    return components_common_dob_input_1.validators.isUserDateAfterSomeDate(dob, getDefaultOldestChildBirthDate());
}
exports.validateChildDob = validateChildDob;
const validateChildren = (childrenDobs) => {
    if (childrenDobs.length === 0)
        return true;
    return childrenDobs.every(validateChildDob);
};
exports.validateChildren = validateChildren;
function isTravelRoomsValid(travelRooms, isSearchForFourRoomsEnabled) {
    const childrenDOBAreValid = (0, exports.validateChildren)(travelRooms.childrenDobs);
    const travellersCount = travelRooms.adults + travelRooms.childrenDobs.length;
    return (childrenDOBAreValid &&
        travellersCount <=
            (isSearchForFourRoomsEnabled
                ? exports.MAX_TRAVELLERS_FOR_FOUR_ROOMS
                : exports.MAX_TRAVELLERS_DEFAULT));
}
exports.isTravelRoomsValid = isTravelRoomsValid;
function hasTravelRoomsEmptyDates(travelRooms) {
    return travelRooms.childrenDobs.some(dob => {
        return !dob || !/^\d+\/\d+\/\d+$/.test(dob);
    });
}
exports.hasTravelRoomsEmptyDates = hasTravelRoomsEmptyDates;
//# sourceMappingURL=TravelRooms.utils.js.map